import { render, staticRenderFns } from "./payrollReportPDFv2.vue?vue&type=template&id=bc798424&scoped=true&"
import script from "./payrollReportPDFv2.vue?vue&type=script&lang=js&"
export * from "./payrollReportPDFv2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc798424",
  null
  
)

export default component.exports